import React, { useState, useEffect, act } from "react";
import "../css/Candidate_dashboard.css";
import Proffessor_admin from "./Professor_admin";
import ConfirmModal from "./ConfirmModal";
import PasswordModal from "./PasswordModal";
import ProfessorsSection from "./ProfessorsSection";
import GenerateSection from "./GenerateSection";
import ConfirmSection from "./ConfirmSection";
import RoundsSection from "./RoundsSection";
import StudentsSection from "./StudentsSection";
import AdminStats from "./AdminStats";
import Paymentstats from "./payment_stats";
import RegPayment from "./RegPayment";
import Payment_excel from "./Payment_excel";
function Admin_sip() {
  const [activeSection, setActiveSection] = useState("professors");
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [selectedDept, setSelectedDept] = useState("");
  const [deptStudents, setDeptStudents] = useState([]);
  const [paymentStats, setPaymentStats] = useState(null);
  const [RegPaymentStats, setRegPaymentStats] = useState(null);
  const [RegpaymentsExcelData, setRegPaymentsExcelData] = useState(null);
  const [roundDetails, setRoundDetails] = useState({
    number: 0,
    allow_reg: false,
    lock_choices: false,
    allow_project_creation: false,
    message: ""
  });
  const [isUpdatingRound, setIsUpdatingRound] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [password, setPassword] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: "",
    message: "",
    confirmText: "",
    onConfirm: () => { }
  });
  const [downloadCSVLoading, setDownloadCSVLoading] = useState(false); 
  const [studentStats, setStudentStats] = useState(null); 

  // Function to show confirmation modal
  const showConfirmation = (title, message, confirmText, onConfirmAction) => {
    setModalConfig({
      title,
      message,
      confirmText,
      onConfirm: () => {
        onConfirmAction();
        setShowConfirmModal(false);
      }
    });
    setShowConfirmModal(true);
  };

  // Fetch departments for dropdown
  const fetchDepartments = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("access_token");
      const response = await fetch("/api/admin/departments", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Failed to fetch departments");
      }
      const data = await response.json();
      setDepartments(data);
    } catch (error) {
      setMessage(`An error occurred: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Download project CSV function
  const handleDownloadProjectCSV = async () => {
    setDownloadCSVLoading(true);
    try {
      const token = localStorage.getItem("access_token");
      
      const response = await fetch("/api/admin/download_project_details", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Failed to download CSV");
      }

      // Create a blob from the response
      const blob = await response.blob();
      
      // Create a download link
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'project_details.csv';
      document.body.appendChild(a);
      a.click();
      
      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      
      // Show success message
      setMessage("Project details CSV downloaded successfully!");
    } catch (err) {
      setMessage(`Download failed: ${err.message}`);
    } finally {
      setDownloadCSVLoading(false);
    }
  };

  // Fetch current round details
  const fetchRoundDetails = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("access_token");
      const response = await fetch("/api/admin/round_details", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Failed to fetch round details");
      }
      const data = await response.json();
      setRoundDetails(data);
    } catch (error) {
      setMessage(`An error occurred: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Handle next step in round progression
  const handleNextStep = async () => {
    if (!password) {
      setMessage("Please enter password");
      return;
    }

    setIsUpdatingRound(true);
    setMessage("");
    try {
      const token = localStorage.getItem("access_token");
      const response = await fetch("/api/admin/start_next_step", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Failed to proceed to next step");
      }

      const data = await response.json();
      setMessage(data.message || "Action completed successfully!");
      setShowPasswordModal(false);
      setPassword("");
      fetchRoundDetails();
    } catch (error) {
      setMessage(`An error occurred: ${error.message}`);
    } finally {
      setIsUpdatingRound(false);
    }
  };

  // Fetch students for a department
  const fetchDeptStudents = async (deptId) => {
    setLoading(true);
    setDeptStudents([]);
    try {
      const token = localStorage.getItem("access_token");
      const response = await fetch(`/api/admin/department_data/${deptId}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Failed to fetch students");
      }
      const data = await response.json();
      setDeptStudents(data);
    } catch (error) {
      setMessage(`An error occurred: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Confirm individual student allotment
  const handleConfirmStudent = async (studentId) => {
    setLoading(true);
    setMessage("");
    try {
      const token = localStorage.getItem("access_token");
      const response = await fetch(`/api/admin/confirm_student/${studentId}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ message: "confirmed" }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Failed to confirm student");
      }

      const data = await response.json();
      setMessage(data.message || "Student confirmed successfully!");

      // Refresh students after confirmation
      if (selectedDept) {
        fetchDeptStudents(selectedDept);
      }
    } catch (error) {
      setMessage(`An error occurred: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Confirm all students in a department
  const handleConfirmAllStudents = async () => {
    if (!selectedDept) {
      setMessage("Please select a department first.");
      return;
    }

    showConfirmation(
      "Confirm All Students",
      "Are you sure you want to confirm all students in this department?",
      "Confirm All",
      async () => {
        setLoading(true);
        setMessage("");
        try {
          const token = localStorage.getItem("access_token");
          const response = await fetch(`/api/admin/department_data/${selectedDept}`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ message: "confirmed" }),
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.detail || "Failed to confirm all students");
          }

          const data = await response.json();
          setMessage(data.message || "All students confirmed successfully!");

          // Refresh students after confirmation
          fetchDeptStudents(selectedDept);
        } catch (error) {
          setMessage(`An error occurred: ${error.message}`);
        } finally {
          setLoading(false);
        }
      }
    );
  };

  // Handle department selection change
  const handleDeptChange = (e) => {
    const deptId = e.target.value;
    setSelectedDept(deptId);
    if (deptId) {
      fetchDeptStudents(deptId);
    } else {
      setDeptStudents([]);
    }
    setMessage("");
  };

  // File upload functions
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setMessage("");
  };

  const handleFileUpload = async () => {
    if (!file) {
      setMessage("Please select an Excel file to upload.");
      return;
    }
    setMessage("Uploading file to backend...");
    try {
      const formData = new FormData();
      formData.append("file", file);

      const token = localStorage.getItem("access_token");

      const response = await fetch("/api/admin/professors/excel", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Upload failed");
      }

      setMessage("File uploaded successfully!");
    } catch (error) {
      setMessage(`An error occurred: ${error.message}`);
    }
  };

  const handleRejectAllStudents = async () => {
    if (!selectedDept) {
      setMessage("Please select a department first.");
      return;
    }

    showConfirmation(
      "Reject All Students",
      "Are you sure you want to reject all students in this department? This action cannot be undone.",
      "Reject All",
      async () => {
        setLoading(true);
        setMessage("");
        try {
          const token = localStorage.getItem("access_token");
          const response = await fetch(`/api/admin/department_data/${selectedDept}`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ message: "rejected" }),
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.detail || "Failed to reject all students");
          }

          const data = await response.json();
          setMessage(data.message || "All students rejected successfully!");

          // Refresh students after rejection
          fetchDeptStudents(selectedDept);
        } catch (error) {
          setMessage(`An error occurred: ${error.message}`);
        } finally {
          setLoading(false);
        }
      }
    );
  };

  // Download professors
  const handleDownload = async () => {
    setMessage("Downloading...");
    try {
      const token = localStorage.getItem("access_token");
      const response = await fetch("/api/admin/professors/excel", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Download failed");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "professors.csv";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setMessage("Download started!");
    } catch (error) {
      setMessage(`An error occurred: ${error.message}`);
    }
  };

  // Generate ID cards
  const handleGenerateIDCards = async () => {
    showConfirmation(
      "Generate ID Cards",
      "Are you sure you want to generate ID cards for all students?",
      "Generate ID Cards",
      async () => {
        setLoading(true);
        setMessage("");

        try {
          const token = localStorage.getItem("access_token");
          if (!token) {
            alert("Authorization token is missing. Please log in.");
            setLoading(false);
            return;
          }

          const response = await fetch("/api/admin/generate_id_card", {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.detail || "Failed to generate ID cards");
          }

          const data = await response.json();
          setMessage(data.message || "ID cards generated successfully!");
        } catch (error) {
          setMessage(`An error occurred: ${error.message}`);
        } finally {
          setLoading(false);
        }
      }
    );
  };

  // Handle email sending
  const handleSendEmail = async () => {
    showConfirmation(
      "Send Emails to Professors",
      "Are you sure you want to send notification emails to all professors?",
      "Send Emails",
      async () => {
        setLoading(true);
        setMessage("");
        try {
          const token = localStorage.getItem("access_token");
          const response = await fetch("/api/admin/send_professor_emails", {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.detail || "Failed to send emails");
          }

          const data = await response.json();
          setMessage(data.message || "Notification emails sent successfully!");
        } catch (error) {
          setMessage(`An error occurred: ${error.message}`);
        } finally {
          setLoading(false);
        }
      }
    );
  };

  // Fetch student stats
  const fetchStudentStats = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("access_token");
      const response = await fetch("/api/admin/stats", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Failed to fetch student stats");
      }
      const data = await response.json();
      setStudentStats(data);
    } catch (error) {
      setMessage(`An error occurred: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data when sections are opened
  useEffect(() => {
    if (activeSection === "confirm") {
      fetchDepartments();
      setSelectedDept("");
      setDeptStudents([]);
    }
    if (activeSection === "rounds") {
      fetchRoundDetails();
    }
    if (activeSection === "stats") {
      fetchStudentStats();
    }
  }, [activeSection]);

  return (
    <div className="cd-container">
      {/* Sidebar */}
      <div className="cd-sidebar">
        <button
          className={`cd-btn ${activeSection === "professors" ? "active" : ""}`}
          onClick={() => setActiveSection("professors")}
        >
          <i className="fas fa-user-tie"></i>
          <span>Professors</span>
        </button>
        <button
          className={`cd-btn ${activeSection === "generate" ? "active" : ""}`}
          onClick={() => setActiveSection("generate")}
        >
          <i className="fas fa-id-card"></i>
          <span> ID Cards</span>
        </button>
        <button
          className={`cd-btn ${activeSection === "confirm" ? "active" : ""}`}
          onClick={() => setActiveSection("confirm")}
        >
          <i className="fas fa-check-circle"></i>
          <span>Allot</span>
        </button>
        <button
          className={`cd-btn ${activeSection === "rounds" ? "active" : ""}`}
          onClick={() => setActiveSection("rounds")}
        >
          <i className="fas fa-sync-alt"></i>
          <span>Rounds</span>
        </button>
        <button
          className={`cd-btn ${activeSection === "admin_professors" ? "active" : ""}`}
          onClick={() => setActiveSection("admin_professors")}
        >
          <i className="fas fa-user-tie"></i>
          <span>Prof Adm</span>
        </button>
        <button
          className={`cd-btn ${activeSection === "students" ? "active" : ""}`}
          onClick={() => setActiveSection("students")}
        >
          <i className="fas fa-users"></i>
          <span>Students</span>
        </button>
        
        <button
          className={`cd-btn ${activeSection === "stats" ? "active" : ""}`}
          onClick={() => setActiveSection("stats")}
        >
          <i className="fas fa-chart-bar"></i>
          <span>Stats</span>
        </button>
        <button
          className={`cd-btn ${activeSection === "payment_stats" ? "active" : ""}`}
          onClick={() => setActiveSection("payment_stats")}
        >
          <i className="fas fa-dollar-sign"></i>
          <span>Payment Stats</span>
        </button>
        <button
          className={`cd-btn ${activeSection === "reg_payment" ? "active" : ""}`}
          onClick={() => setActiveSection("reg_payment")}
        >
          <i className="fas fa-money-bill-wave"></i>
          <span>Registration Payments</span>
        </button>
        <button
          className={`cd-btn ${activeSection === "RegpaymentsExcelData" ? "active" : ""}`}
          onClick={() => setActiveSection("RegpaymentsExcelData")}
        >
          <i className="fas fa-file-excel"></i>
          <span>Payment Excel</span>
        </button>
        <button
          className="cd-btn"
          onClick={() => {
            localStorage.removeItem("token");
            window.location.href = "/login";
          }}
        >
          <i className="fas fa-sign-out-alt"></i>
          <span>Logout</span>
        </button>
      </div>

      {/* Main Content */}
      <div className="cd-main-content">
        {activeSection === "professors" && (
          <ProfessorsSection
            file={file}
            loading={loading}
            message={message}
            handleFileChange={handleFileChange}
            handleFileUpload={handleFileUpload}
            handleDownload={handleDownload}
            handleSendEmail={handleSendEmail}
            handleDownloadProjectCSV={handleDownloadProjectCSV} // Added this prop
            downloadCSVLoading={downloadCSVLoading} // Added this prop
          />
        )}
        {
          activeSection === "RegpaymentsExcelData" && <Payment_excel />
        }

        {activeSection === "generate" && (
          <GenerateSection
            loading={loading}
            handleGenerateIDCards={handleGenerateIDCards}
          />
        )}
        {activeSection === "payment_stats" && <Paymentstats />}
        {
          activeSection === "reg_payment" && <RegPayment />
        }

        {activeSection === "confirm" && (
          <ConfirmSection
            departments={departments}
            selectedDept={selectedDept}
            deptStudents={deptStudents}
            loading={loading}
            message={message}
            handleDeptChange={handleDeptChange}
            handleConfirmStudent={handleConfirmStudent}
            handleConfirmAllStudents={handleConfirmAllStudents}
            handleRejectAllStudents={handleRejectAllStudents}
          />
        )}
        {activeSection === "students" && <StudentsSection />}
        {activeSection === "stats" && <AdminStats stats={studentStats} loading={loading} />}
        {activeSection === "rounds" && (
          <RoundsSection
            roundDetails={roundDetails}
            isUpdatingRound={isUpdatingRound}
            showPasswordModal={showPasswordModal}
            setShowPasswordModal={setShowPasswordModal}
            password={password}
            setPassword={setPassword}
            message={message}
            handleNextStep={handleNextStep}
          />
        )}

        {activeSection === "admin_professors" && <Proffessor_admin />}
      </div>

      {/* Password Modal */}
      {showPasswordModal && (
        <PasswordModal
          title="Confirm Action"
          onConfirm={handleNextStep}
          onCancel={() => {
            setShowPasswordModal(false);
            setPassword("");
          }}
          password={password}
          setPassword={setPassword}
          isLoading={isUpdatingRound}
        />
      )}


      {/* Confirmation Modal */}
      {showConfirmModal && (
        <ConfirmModal
          title={modalConfig.title}
          message={modalConfig.message}
          confirmText={modalConfig.confirmText}
          onConfirm={modalConfig.onConfirm}
          onCancel={() => setShowConfirmModal(false)}
          isLoading={loading}
        />
      )}
    </div>
  );
}

export default Admin_sip;